define(function (require) {
    var dialog = require('dialog'),
        avalon = require('avalon'),
        chooserDialog = null,
        location = window.GLOBAL_LOCATION,
        gOnSelect = null,
        html = [
            "<div class='dest-chooser-wrap st' ms-controller='destinationChooser'>",
            "<ul class='provinces clearfix'>",
            "<li ms-repeat='provinces' ms-class-1='choosed:el.id===choosedProvinceId' ms-click='chooseProvince(el)'>[[el.name]]</li>",
            '</ul>',
            "<ul class='citys clearfix'><li ms-repeat='citys' ms-click='chooseCity(el)'>[[el.name]]</li></ul>",
            '</div>'
        ].join(''),
        vmodel = avalon.define({
            $id: 'destinationChooser',
            provinces: location,
            choosedProvinceId: 0,
            chooseProvince: function (province) {
                vmodel.choosedProvinceId = province.id;
                vmodel.citys = province.city;
                if (province.muni === '1') {
                    vmodel.chooseCity(vmodel.citys[0]);
                }
            },
            citys: [],
            chooseCity: function (city) {
                gOnSelect && gOnSelect(city.$model);
                chooserDialog.close();
            }
        });

    return {
        open: function (onSelect, cityId) {
            if (!chooserDialog) {
                chooserDialog = dialog.init({
                    title: '选择目的地',
                    html: html,
                    width: 520,
                    onClose: function () {
                        vmodel.citys.clear();
                        vmodel.choosedProvinceId = 0;
                    }
                });
                avalon.scan(chooserDialog.domBody.get(0), vmodel);
            }

            if (cityId) {
                $.each(location, function (i, province) {
                    var find = false;
                    $.each(province.city, function (j, city) {
                        if (city.id === cityId) {
                            if (province.muni !== '1') {
                                vmodel.citys = province.city;
                                vmodel.choosedProvinceId = province.id;
                            }
                            find = true;
                            return false;
                        }
                    });
                    if (find) {
                        return false;
                    }
                });
            }

            gOnSelect = onSelect;
            chooserDialog.open();
        }
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/destinationChooser.js